import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseUpdateDto } from '../../base/baseUpdate.dto'

@ArgsType()
export class UpdateArcTeamMemberDto extends BaseUpdateDto<UpdateArcTeamMemberDto> {
  @Field(t => Int)
  teamId!: number

  @Field(t => Int, { nullable: true })
  status?: number // Approved, blocked, rejected etc.

  @Field(t => Int, { nullable: true })
  reviewerStatus?: number // Approved, blocked, rejected etc.

  @Field(t => Int, { nullable: true })
  type?: number // normal / VIP etc

  @Field(t => Int, { nullable: true })
  statusReasonType?: number

  @Field({ nullable: true })
  statusReason?: string

  @Field(t => Boolean, { nullable: true })
  report?: boolean
}
